<template>
  <div class="tax_compare">
    <div class="layout">
      <back-button
        class="back-button-custom wrap-back-btn"
        caption="ย้อนกลับ"
      />
    </div>

    <div class="ptc-body">
      <div class="ptcb-title">
        <div class="ptcbt-wrapper">
          <h3>เปรียบเทียบการเสียภาษี</h3>
          <div>
            มาลองคำนวณดูว่าการเปรียบเทียบการเสียภาษีของ
            บุคคลธรรมดาและนิติบุคคลเป็นอย่างไร
          </div>
        </div>
      </div>

      <div class="ptcb-header">
        <div class="ptcbh-left">
          <div class="ptcbh-block">
            <img
              class="ptcbh-img"
              src="@/assets/icons/Single Neutral.svg"
              alt="Single Neutral"
            />
          </div>
          <h4>
            บุคคลธรรมดา <br />
            ({{ lableCharter }})
          </h4>
        </div>
        <div class="ptcbh-right">
          <div class="ptcbh-block">
            <img
              class="ptcbh-img"
              src="@/assets/icons/Building Flag.svg"
              alt="Building Flag"
            />
          </div>
          <h4>นิติบุคคล</h4>
        </div>
      </div>

      <div class="ptcb-row">
        <div class="ptcbr-topic">{{ jobIncomeLable }}</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left ptcbrd-link">
            <currency mode="readOnly" :value="personal.totalIncome" />
          </div>
          <div class="ptcbrd-right ptcbrd-link">
            <currency mode="readOnly" :value="corporation.totalIncome" />
          </div>
        </div>
      </div>

      <div class="ptcb-row">
        <div class="ptcbr-topic">{{ jobCostLable }}</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left ptcbrd-link">
            <currency mode="readOnly" :value="personal.totalExpense" />
          </div>
          <div class="ptcbrd-right ptcbrd-link">
            <currency mode="readOnly" :value="corporation.totalExpense" />
          </div>
        </div>
      </div>
      <div class="ptcb-row" v-if="deducts.personal > 0">
        <div class="ptcbr-topic">ค่าลดหย่อนส่วนตัว</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.personal"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.spouse > 0">
        <div class="ptcbr-topic">ค่าลดหย่อนคู่สมรส (สูงสุด ฿60,000)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.spouse"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.pregnancy > 0">
        <div class="ptcbr-topic">ค่าคลอดบุตร (สูงสุด ฿60,000/คน)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.pregnancy"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.children > 0">
        <div class="ptcbr-topic">บุตร (สูงสุด ฿30,000/คน)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.children"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.parents > 0">
        <div class="ptcbr-topic">พ่อแม่ (สูงสุด ฿30,000/คน)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.parents"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.handicaps > 0">
        <div class="ptcbr-topic">ผู้พิการ/ทุพลภาพ (สูงสุด ฿60,000/คน)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.handicaps"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.houseInterest > 0">
        <div class="ptcbr-topic">ดอกเบี้ยบ้าน (สูงสุด ฿100,000)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.houseInterest"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.firstHouse > 0">
        <div class="ptcbr-topic">บ้านหลังแรก (สูงสุด ฿200,000)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.firstHouse"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.lifeInsurance > 0">
        <div class="ptcbr-topic">ประกันชีวิตตนเอง (สูงสุด ฿100,000)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.lifeInsurance"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.healthInsurance > 0">
        <div class="ptcbr-topic">ประกันสุขภาพตนเอง (สูงสุด ฿15,000)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.healthInsurance"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div
        class="ptcb-row"
        v-if="personal.totalDeducts.parentHealthInsurance > 0"
      >
        <div class="ptcbr-topic">ประกันสุขภาพพ่อแม่ (สูงสุด ฿15,000)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.parentHealthInsurance"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.sso > 0">
        <div class="ptcbr-topic">ประกันสังคม (สูงสุด ฿9,000)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.sso"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.pvd > 0">
        <div class="ptcbr-topic">PVD/ กบข./ ครูเอกชน</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.pvd"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.ssf > 0">
        <div class="ptcbr-topic">กองทุน SSF (สูงสุด ฿200,000)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.ssf"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.rmf > 0">
        <div class="ptcbr-topic">กองทุน RMF (สูงสุด ฿500,000)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.rmf"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.specialDonation > 0">
        <div class="ptcbr-topic">บริจาคเพื่อการศึกษา/ โรงพยาบาล</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.specialDonation"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.generalDonation > 0">
        <div class="ptcbr-topic">บริจาคทั่วไป</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.generalDonation"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row" v-if="personal.totalDeducts.partyDonation > 0">
        <div class="ptcbr-topic">บริจาคพรรคการเมือง (สูงสุด ฿10,000)</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              mode="readOnly"
              class="custom-input"
              v-model="personal.totalDeducts.partyDonation"
            />
          </div>
          <div class="ptcbrd-right">0.00</div>
        </div>
      </div>
      <div class="ptcb-row">
        <div class="ptcbr-topic">อัตราภาษี</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">{{ personal.maxTaxRate }}%</div>
          <div class="ptcbrd-right">{{ corporation.maxTaxRate }}%</div>
        </div>
      </div>

      <div class="ptcb-row">
        <div class="ptcbr-topic">ค่าภาษี</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left" :class="[!isCorpLess ? 'is-less' : '']">
            <currency mode="readOnly" :value="personal.tax" />
          </div>
          <div
            class="ptcbrd-right ptcbrd-text-bold ptcbrd-success"
            :class="[isCorpLess ? 'is-less' : '']"
          >
            <currency mode="readOnly" :value="corporation.tax" />
          </div>
        </div>
      </div>

      <div class="gvcb-status">
        <img
          class="gvcbs-background"
          :src="isCorpLess ? BACKGROUNDSUCCESS : BACKGROUNDERROR"
          alt="background-success"
        />
        <div class="gvcbs-text">
          <h4 v-if="isCorpLess">เป็นนิติบุคคลจะเสียภาษีน้อยกว่า</h4>
          <h4 v-else>เป็นนิติบุคคลจะเสียภาษีมากกว่า</h4>
          <h1>
            <currency mode="readOnly" :value="diffValue" />
          </h1>
        </div>
      </div>

      <material-button class="ptcb-button" @clickButton="goToCheat">
        ถัดไป
      </material-button>
    </div>
  </div>
</template>

<script>
import BACKGROUNDSUCCESS from "@/assets/icons/background-success.svg";
import BACKGROUNDERROR from "@/assets/icons/background-error.svg";

import * as taxPersonal from "@/helper/personal_tax_helper";
import * as taxCorperation from "@/helper/corporate_tax_helper";

export default {
  name: "PersonTypeCompare",
  computed: {
    personal: function () {
      const onlineSelling = this.$store.getters["taxInfo/getIncome"]
        .onlineSelling;
      const salary = this.$store.getters["taxInfo/getIncome"].salary;
      // let cost = 0;
      // const isRegisteredVat = this.$store.getters["questions/getAnswers"]
      //   .isRegisteredVat;
      // const goodsType = this.$store.getters["questions/getAnswers"].goodsType;
      const isCharter = this.$store.getters["taxInfo/getCharter"];
      const totalIncomeOnlineSelling = onlineSelling * 12;
      const totalIncomeSalary = salary * 12;

      // if (isRegisteredVat && goodsType) {
      //   cost = this.$store.getters["taxInfo/getExpense"].cost;
      // }

      const expense = {
        ...this.$store.getters["taxInfo/getFilterExpense"],
      };

      const totalExpense = Object.values(expense).reduce(
        (sum, value) => sum + parseFloat(value) * 12,
        0
      );

      const deducts = this.$store.getters["taxInfo/getDeduct"];

      const personal = taxPersonal.calculatePersonalTaxInfo({
        incomes: {
          onlineSelling: {
            income: totalIncomeOnlineSelling,
            expense: totalExpense,
            isCharter: isCharter,
          },
          salary: {
            income: totalIncomeSalary,
            expense: 0,
          },
        },
        deducts: deducts,
      });
      return { ...personal, maxTaxRate: personal.maxTaxRate * 100 };
    },
    corporation: function () {
      const onlineSelling = this.$store.getters["taxInfo/getIncome"]
        .onlineSelling;
      const salary = this.$store.getters["taxInfo/getIncome"].salary;

      const totalIncomeOnlineSelling = onlineSelling * 12;
      const totalIncomeSalary = salary * 12;

      // const isRegisteredVat = this.$store.getters["questions/getAnswers"]
      //   .isRegisteredVat;
      // const goodsType = this.$store.getters["questions/getAnswers"].goodsType;
      // let cost = 0;

      // if (isRegisteredVat && goodsType) {
      //   cost = this.$store.getters["taxInfo/getExpense"].cost;
      // }

      const expense = {
        ...this.$store.getters["taxInfo/getFilterExpense"],
      };

      const totalExpense = Object.values(expense).reduce(
        (sum, value) => sum + parseFloat(value) * 12,
        0
      );

      const corporation = taxCorperation.calculateCorporateTaxInfo({
        incomes: {
          onlineSelling: {
            income: totalIncomeOnlineSelling,
            expense: totalExpense,
          },
          salary: {
            income: totalIncomeSalary,
            expense: 0,
          },
        },
      });
      return { ...corporation, maxTaxRate: corporation.maxTaxRate * 100 };
    },
    isCorpLess: function () {
      return this.corporation.tax - this.personal.tax < 0;
    },
    diffValue: function () {
      const value = Math.abs(this.personal.tax - this.corporation.tax);
      return value;
    },
  },
  data() {
    const isCharter = this.$store.getters["taxInfo/getCharter"];
    const deducts = this.$store.getters["taxInfo/getDeduct"];
    const isRegisteredVat = this.$store.getters["questions/getAnswers"]
      .isRegisteredVat;
    const goodsType = this.$store.getters["questions/getAnswers"].goodsType;

    let jobIncomeLable = isRegisteredVat ? "รายได้ต่อปี" : "รายได้ต่อปี";
    let jobCostLable =
      isRegisteredVat && goodsType ? "รายจ่ายต่อปี" : "รายจ่ายต่อปี";

    return {
      deducts,
      BACKGROUNDSUCCESS,
      BACKGROUNDERROR,
      jobIncomeLable,
      jobCostLable,
      lableCharter: isCharter ? "หักค่าใช้จ่ายเหมา" : "หักค่าใช้จ่ายตามจริง",
    };
  },
  methods: {
    goToCheat() {
      this.$router.push({
        path: "/questions/cheat",
      });
    },
  },
};
</script>

<style scoped>
.tax_compare {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.wrap-back-btn {
  max-width: 355px;
}
.ptc-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  position: relative;
  margin-top: 12px;
  margin-bottom: 26px;
}
.ptcb-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
  text-align: left;
  max-width: 355px;
}
.custom-input {
  max-width: 179.5px;
  border: none;
  text-align: end;
}
.ptcb-header {
  width: 100%;
  display: flex;
  margin-bottom: 16px;
  margin-top: 44px;
  max-width: 352px;
}
.ptcbh-block {
  border-radius: 2px;
}
.ptcbh-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.ptcbh-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.ptcbh-img {
  width: 40px;
  height: 40px;
}

.ptcb-row {
  width: 100%;
  max-width: 351px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
}
.ptcbr-topic {
  width: 100%;
  display: flex;
  align-items: center;
  text-align: left;
  color: #acb1bf;
  border-bottom: 1px solid #d8d9e0;
  margin-bottom: 8px;
}
.ptcbr-detail {
  width: 100%;
  display: flex;
}
.ptcbr-detail > div {
  flex: 1;
  text-align: right;
}
.ptcbrd-left {
}
.ptcbrd-right {
}
.ptcbrd-text-bold {
  font-weight: bold;
}
.ptcbrd-link {
  text-decoration: underline;
  color: #29a9e2;
}
.ptcbrd-success {
  color: #9bcc55;
}

.gvcb-status {
  width: 100%;
  max-width: 351px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 276px;
  margin-top: 34px;
  margin-bottom: 31px;
}
.gvcbs-background {
  position: absolute;
  z-index: -1;
  width: inherit;
}
.gvcbs-text-bold input,
.gvcbs-text-bold {
  font-weight: bold;
}
.gvcbs-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}
.gvcbs-text input {
  color: white;
  text-align: center;
}
.ptcb-button {
  max-width: 352px;
  margin-bottom: 14px;
}
.custom-input-blue {
  text-decoration: underline;
  color: #29a9e2;
  cursor: pointer;
  background: transparent;
}
.is-less > input {
  color: #9bcc55 !important;
  font-weight: bold;
}
.layout {
  width: 100%;
  padding: 0px 30px;
  max-width: 1120px;
  box-sizing: border-box;
  margin-top: 24px;
}

@media (min-width: 600px) {
  .wrap-back-btn {
    max-width: 1120px;
    padding: 0 20px;
  }
  .ptcb-row,
  .ptcb-title,
  .ptcb-header {
    max-width: 600px;
  }
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .layout {
    padding: 0;
  }
}
</style>
